import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import {
  TextInput, IntInput
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { virtualsensortext } from "variables/MBM/virtualsensor";
import { postVirtualSensor, putVirtualSensor, getMBMEquipments } from "services/ConfigServices";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { typeData } from "variables/MBM/lists/virtualsensor";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput";
import { set } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import HelpIcon from '@mui/icons-material/Help';


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  icon: {
    left: "5px",
    top: "30px",
    width: "17px",
    height: "17px",
    position: "relative",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#3E8FC6",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  submitButtonEdit: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabledEdit: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "5ch",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const HelpLine = styled.p`
  text-align : left;
`;

function VirtualSensorDialog(props) {
  const { closeModal, refetch, currentSensor } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, architecture } = advancedSearchContext;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin"); //not in prod yet

  const [pointsData, setPointsData] = useState([]);

  const [formula, setFormula] = useState(currentSensor?.formula || "");
  const [frequency, setFrequency] = useState(currentSensor?.frequency || 5);
  const [triggeredPoints, setTriggeredPoints] = useState(currentSensor?.triggeredPoints || []);

  const [name, setName] = useState(currentSensor?.name || "");
  const [groups, setGroups] = useState(currentSensor?.groupid ? "" + currentSensor.groupid : "");
  const [definition, setDefinition] = useState(currentSensor?.otherparameters?.definition || "");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [syncciteos, setSyncciteos] = useState(currentSensor?.otherparameters?.syncciteos || false);
  const [replacementvalues, setReplacementvalues] = useState(currentSensor?.otherparameters?.replacementvalues || []);
  const [alert, setAlert] = React.useState(null);


  useEffect(() => {
    if (
      name.length > 0 &&
      formula &&
      (groups.length > 0 && groups !== "0") &&
      frequency &&
      definition
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name, groups, formula, frequency, definition]);

  useEffect(() => {
    if (groups.length > 0 && groups !== "0") {
      axios
        .get(
          getMBMEquipments(groups, 'all'),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpPointsData = res.data.points?.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setPointsData(tmpPointsData || []);
        });
    }
  }, [groups]);



  const handleSubmit = async (event) => {
    if (currentSensor)
      updateSensor(event);
    else
      createSensor(event);
  };

  const isGroupInPath = (archi, idsearched, idgroup, inpath) => {
    let isinpath = false;
    if (idgroup === idsearched)
      return true;
    for (var i = 0; i < archi.length; i++) {
      if (archi[i].id === idgroup) {
        return inpath;
      }
      else if (archi[i].children && archi[i].children.length > 0) {
        let found = inpath;
        if (archi[i].id === idsearched) {
          found = true;
        }
        isinpath = isGroupInPath(archi[i].children, idsearched, idgroup, found);
      }
      if (isinpath)
        break;
    }
    return isinpath;
  }


  const handleReplacementValuesChange = (value) => { setReplacementvalues(value); };
  const handleSyncciteosChange = (e) => { setSyncciteos(!syncciteos); };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleFormulaChange = (event) => { setFormula(event.target.value); };
  const handleFrequencyChange = (event) => { setFrequency(event.target.value); };
  const handleDefinitionChange = (event) => { setDefinition(event.target.value); };
  const selectedPoint = () => {
    let selected = pointsData.filter((obj) =>
      triggeredPoints.includes(obj.id));
    return selected;
  };
  const handlePointsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setTriggeredPoints(newArray);
  };

  const createSensor = async (event) => {
    let otherparameters = {
      definition,
      syncciteos,
      replacementvalues
    };
    await axios
      .post(
        postVirtualSensor(),
        {
          groups,
          name,
          formula,
          frequency,
          triggeredPoints,
          otherparameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Capteur virtuel créé");
        } else setNotification("error", res.data.message);
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error.response);
        setNotification("error", "Une erreur est survenue : " + error.response?.data?.message);
      });
  };

  const updateSensor = async (event) => {
    let otherparameters = {
      ...currentSensor.otherparameters,
      definition,
      syncciteos,
      replacementvalues
    };
    await axios
      .put(
        putVirtualSensor(currentSensor.id),
        {
          groups,
          name,
          formula,
          frequency,
          triggeredPoints,
          otherparameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Capteur virtuel modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const hideAlert = () => {
    setAlert(null);
  };
  const getTooltipHelp = () => {
    const tooltipAlert = (
      <SweetAlert
        style={{
          fontSize: '14px',
          fontFamily: '"Source Sans Pro",sans-serif',
          color: ' #3c4858',
          display: "block", marginTop: "-50px", width: "25rem"
        }}
        title=""
        showConfirm={false}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
      >
        <div style={{ fontSize: "14px" }}>
          <p><b>Fonctions de la formule :</b></p>
          <HelpLine>{"{AVG[XXX]} : la moyenne des valeurs du point"}</HelpLine>
          <HelpLine>{"{SUM[XXX]} : la somme des valeurs du point"}</HelpLine>
          <HelpLine>{"{MIN[XXX]} : le plus petite des valeurs du point"}</HelpLine>
          <HelpLine>{"{MAX[XXX]} : la plus grande des valeurs du point"}</HelpLine>
          <HelpLine>{"Opérateurs acceptés : '+','-','/','*','>','<','==','>=','<=','!='"}</HelpLine>
          <HelpLine>{"Les opérateurs de comparaison renvoie 0 ou 1 ('3>=2' renvoie 1)"}</HelpLine>
        </div>
      </SweetAlert>
    );
    setAlert(tooltipAlert);
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();
  const valuelist = [];
  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            < div >
              <TextInput
                isRequired
                inputTitle={virtualsensortext.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                disabled={!mbm_admin}
              />
            </div>
            {/* <div>
              <IntInput
                isRequired
                inputTitle={virtualsensortext.frequency}
                intInput={frequency}
                handleIntInputChange={handleFrequencyChange}
                disabled={!mbm_admin}
              />
            </div> */}
            <div>
              <AutocompleteMultiselectInputById
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={virtualsensortext.triggeredPoints}
                selected={selectedPoint()}
                list={pointsData}
                handleChange={handlePointsChange}
              />
            </div>
            <div>
              <GridContainer>
                <GridItem xs={11} sm={11} md={11} lg={11} className={"noPadding"}>
                  <TextInput
                    inputTitle={virtualsensortext.formula}
                    textInput={formula}
                    handleTextInputChange={handleFormulaChange}
                    multiline
                    rows={4}
                    disabled={!mbm_admin}
                  />

                </GridItem>
                <GridItem xs={1} sm={1} md={1} lg={1}>
                  <HelpIcon className={classes.icon} onClick={() => getTooltipHelp()} />
                </GridItem>
              </GridContainer>
            </div>
            <div>
              <CustomSelect
                inputTitle={virtualsensortext.definition}
                selectValue={definition}
                handleSelectValueChange={handleDefinitionChange}
                data={typeData}
                disabled={!mbm_admin}
              />
            </div>
            {
              isGroupInPath(architecture, "" + 41604, "" + chartIdGroup, false) ?
                <>
                  <div>
                    <CustomSwitch
                      style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                      inputTitle={virtualsensortext.syncciteos}
                      checkedState={syncciteos}
                      handleSwitchChange={handleSyncciteosChange}
                    />
                  </div>
                  {
                    syncciteos ?
                      <GridItem xs={12} sm={12} md={12} lg={12}>
                        <div>
                          <AutocompleteTagsInput
                            specialWidth={"97%"}
                            inputMargin={"1rem 0rem 0rem"}
                            inputTitle={virtualsensortext.replacementvalues}
                            selected={replacementvalues}
                            list={valuelist}
                            handleChange={(value) => handleReplacementValuesChange(value)}
                          />
                        </div>
                      </GridItem> : <></>
                  }
                </> : <></>
            }
          </GridItem>

          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <EmbeddedEntitesTree
                  selectedIds={setGroups}
                  userSelectedIds={groups}
                  filterfromnode={chartIdGroup[0]}
                />
              </ImageList>
            </div>
          </GridItem>

        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            currentSensor ?
              buttonDisabled
                ? classes.submitButtonDisabledEdit
                : classes.submitButtonEdit
              :
              buttonDisabled
                ? classes.submitButtonDisabled
                : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
      {alert}
    </>
  );
}

export default VirtualSensorDialog;
